import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  message: string;

  constructor(
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  /**
   * Opens a MatSnackBar from Component with a Config.
   *
   * @param key Set the key to be used to lookup the message data on the Translation Table
   * @param durationInSeconds Set the display time of the snackbar in seconds.
   * @param styleClass Set the styling of the snackbar (more styles can be added via the component css).
   */
  open(key: string, durationInSeconds: number, styleClass: string, additionally: string = '') {
    const config: MatSnackBarConfig = {
      data: this.translate.instant(key) + ' ' + additionally,
      duration: durationInSeconds * 1000,
      panelClass: [styleClass],
    };

    this.snackBar.openFromComponent(SnackbarComponent, config);
  }
}
